module.exports = __webpack_public_path__ + "67a851cc14fff5b6613de6ce5fd4a201.glb";